import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ReviewStatusFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'review_status'
  alias: 'Review Status'
  facetName: 'review_status'
  humanize: true
  selectAll: true

  getAppliedValues: ->
    return @searchQuery.get('review_status')

  addFilter: (value) ->
    @searchQuery.addReviewStatus(value)